import { useLoaderData } from 'react-router-dom';
import { DonationsSummaryByDateLoaderData } from '../types';

export const useDonationsSummaryByDateLoaderData =
    (): DonationsSummaryByDateLoaderData => {
        const requests = useLoaderData() as DonationsSummaryByDateLoaderData;

        return {
            donationsData: requests?.donationsData,
        };
    };
